"use strict";

/**
 * @desc 根据不同环境配置服务器
 */
var addressConfig = {
  // 开发环境
  dev: {
    // 埋点地址
    COUNTLY_ADDRESS: "http://10.200.111.114:8181",
    COUNTLY_APPKEY: "596a25bc78252d3655c4a14651f10bacf11fb898",
    // 用户中心接口地址（新地址）
    EXCHANGEAPI_ADDRESS: "http://10.190.65.49:9010",
    CALENDAR_SYNC_API_ADDRESS: "http://10.190.46.123",
    // 用户中心统一登录页面
    SSOURL:
      "http://passport-test.test.geely.com/html/?appKey=3b375041-e5a9-4fdc-bbcd-71fe50348386&redirectUrl=",
    getSSOURL: function() {
      if (window.location.origin.includes("aerofugia.com")) {
        return "http://passport-test.test.geely.com/html/?appKey=e5d18532-1587-4ec5-b27c-3ca326ec30eb&redirectUrl=";
      } else {
        return "http://passport-test.test.geely.com/html/?appKey=3b375041-e5a9-4fdc-bbcd-71fe50348386&redirectUrl=";
      }
    }
  },
  // 测试环境
  test: {
    CDN_ADDRESS: "/",
    COUNTLY_ADDRESS: "http://10.200.111.114:8181",
    COUNTLY_APPKEY: "596a25bc78252d3655c4a14651f10bacf11fb898",
    EXCHANGEAPI_ADDRESS: "http://10.190.65.49:9010",
    CALENDAR_SYNC_API_ADDRESS: "http://10.190.46.123",
    getSSOURL: function() {
      if (window.location.origin.includes("aerofugia.com")) {
        return "http://passport-test.test.geely.com/html/?appKey=e5d18532-1587-4ec5-b27c-3ca326ec30eb&redirectUrl=";
      } else {
        return "http://passport-test.test.geely.com/html/?appKey=3b375041-e5a9-4fdc-bbcd-71fe50348386&redirectUrl=";
      }
    },
    SSOURL:
      "http://passport-test.test.geely.com/html/?appKey=3b375041-e5a9-4fdc-bbcd-71fe50348386&redirectUrl="
  },
  // 预发环境
  pre: {
    COUNTLY_ADDRESS: "http://10.200.111.114:8181",
    COUNTLY_APPKEY: "596a25bc78252d3655c4a14651f10bacf11fb898",
    EXCHANGEAPI_ADDRESS: "http://10.190.65.49:9010",
    getSSOURL: function() {
      if (window.location.origin.includes("aerofugia.com")) {
        return "http://passport-test.test.geely.com/html/?appKey=e5d18532-1587-4ec5-b27c-3ca326ec30eb&redirectUrl=";
      } else {
        return "http://passport-test.geely.com/html/?appKey=3b375041-e5a9-4fdc-bbcd-71fe50348386&redirectUrl=";
      }
    },
    SSOURL:
      "http://passport-test.geely.com/html/?appKey=3b375041-e5a9-4fdc-bbcd-71fe50348386&redirectUrl="
  },
  // 正式环境
  prod: {
    CDN_ADDRESS: "/",
    COUNTLY_ADDRESS: "https://ub-api.geely.com",
    COUNTLY_APPKEY: "5ed1a5ab61ab6c19f5f6df9ace46ab68dce6e1ab",
    EXCHANGEAPI_ADDRESS: "https://mailservice.geely.com/exchangeapi",
    CALENDAR_SYNC_API_ADDRESS: "http://10.190.46.123",
    getSSOURL: function() {
      if (window.location.origin.includes("aerofugia.com")) {
        return "https://passport.geely.com/html/?appKey=6469a353-fd0f-4eef-bdd3-42e379c22b04&redirectUrl=";
      } else {
        return "https://passport.geely.com/html/?appKey=e769c60a-eea5-4604-bb27-93d50aabe15f&redirectUrl=";
      }
    },
    SSOURL:
      "https://passport.geely.com/html/?appKey=e769c60a-eea5-4604-bb27-93d50aabe15f&redirectUrl="
  }
};

// 根据不同环境读取不同配置
var config = addressConfig[process.env.NODE_CONFIG || "dev"];

module.exports = config;



//////////////////
// WEBPACK FOOTER
// ./config/address.config.js
// module id = zirW
// module chunks = 10